import type { TourStep } from '../types';

export const creatingAppraisalSteps: TourStep[] = [
  {
    target: '[data-tour="appraisals-header"]',
    title: 'Appraisal Dashboard',
    content:
      'This is your central hub for all appraisal work — creating reports, tracking progress, managing engagement letters, and accessing tools.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="appraisals-stats"]',
    title: 'Your Workload at a Glance',
    content:
      'These cards show your current pipeline. Use the range filter (top-right) to see this week\'s, month\'s, or year\'s numbers. Tap any card for a quick sense of where things stand.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="appraisals-new-button"]',
    title: 'Create a New Appraisal',
    content:
      'Click "New" to start. You can create an Appraisal, URAR Report, or Engagement Letter. The creation wizard walks you through property search, client info, and report settings. Try clicking it to see the options.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve seen the menu',
  },
  {
    target: '[data-tour="appraisals-recent"]',
    title: 'Your Active Reports',
    content:
      'All your appraisals appear here sorted by last updated. Click any row to jump into the editor. Use the status tabs to filter by Draft, In Progress, Review, etc. Try clicking a tab.',
    placement: 'top',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="appraisals-quick-actions"]',
    title: 'Quick Actions & Navigation',
    content:
      'Jump to the full Appraisal Log for advanced filtering and export, open standalone Tools (DCF, Market Report, Tax Appeal, Sketch), or check the Recycle Bin for deleted reports.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="appraisals-engagements"]',
    title: 'Engagement Letters',
    content:
      'Recent engagement letters also appear here. Click one to open the editor, or "View All" to manage them in the dedicated Engagement Log.',
    placement: 'top',
    spotlightClicks: true,
  },
];
